// extracted by mini-css-extract-plugin
export default {"tooltip":"mL-z","arrow":"nL-z"};